import { render, staticRenderFns } from "./MyColorItems.vue?vue&type=template&id=f1927eea&"
import script from "./MyColorItems.vue?vue&type=script&lang=ts&"
export * from "./MyColorItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports